import { lazy } from 'react';

const Virtuals = lazy(
	() =>
		import(
			/* webpackChunkName: "virtuals" */
			'./virtuals-container'
		)
);

export default Virtuals;
